export default "__VITE_ASSET__CmPRhwEw__"